import { baseCrudFactory } from "~/stores/base.crud.store.ts"
import {
    useDevisStore,
    useAdresseStore,
    useClientStore,
    usePersonnelStore,
} from "~/stores"
import { groupById } from "~/helpers"
import { ProjetModel } from "~/model"

function isActive(p) {
    return (
        (!p.DATE_SANS_SUITE || p.DATE_SANS_SUITE === "") &&
        !p.REFUSE &&
        p.TYPE_PROJET == 0
    )
}

function hasActiveRdv(p) {
    if (!Array.isArray(p.RDVS)) return false
    return p.RDVS.some((rdv) => !rdv.SUPPRIME)
}

export const useProjetStore = baseCrudFactory({
    endpoint: "projets",
    primaryKey: "IDPROJET",
    title: "projet",
    startDateKey: "DATE_CREATION",
    endDateKey: "DATE_CREATION",
    showDelete: false,
    model: ProjetModel,
    modules: {
        devis: () => useDevisStore(),
        adresse: () => useAdresseStore(),
        adresse_chantier: () => useAdresseStore(),
        adresse_client: () => useAdresseStore(),
        client: () => useClientStore(),
        personnel: () => usePersonnelStore(),
    },
    filters: {
        to_assignment: (p) => isActive(p) && p.IDRESPONSABLEPROJET == 0,
        to_contact: (p) =>
            isActive(p) &&
            p.IDRESPONSABLEPROJET != 0 &&
            !p.RELANCE_INTERMEDIAIRE &&
            !hasActiveRdv(p) &&
            p.IDETAT_PROJET == 1,
    },
    getters: {
        projetsByIdClient() {
            return groupById(this.items, "IDCLIENT")
        },
    },
})
